




















































































































































































































































































































































































































































































import { mapGetters } from 'vuex';

import {
  IWorkflowFormSectionFieldData,
  WorkflowConstraintActionEnum,
  IWorkflowFormSectionFieldConstraint,
  IWorkflowFormFieldData,
  IWorkflowFormTemplateRevision,
  WorkflowFormSectionFieldConstraintCondition,
  WorkflowConstraintConditionTypeEnum,
  WorkflowFormFieldConstraintComparisonOperators,
  WorkflowFormFieldConstraintConditionType,
  IWorkflowFormFieldConstraintConditionType,
  IWorkflowFormFieldConstraintComparisonType,
  IWorkflowFormSectionFieldConstraintConditionData,
  WorkflowFormFieldTypeEnum,
  OPTION_BASED_FIELD_TYPES,
  WorkflowConstraintConditionComparisonOperators,
  WorkflowFormFieldType
} from '@/models';
import { ALForm } from '@/common/component.types';
import { numericValidator, requiredValidator } from '@/utils/validators';

import AlTooltipBtn from '@/components/common/AlTooltipBtn.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import { defineComponent, PropType, ref } from '@vue/composition-api';
import { extractTextFromHtml } from '@/utils/helpers';

export default defineComponent({
  name: 'FormBuilderConstraintConditionsDrawer',

  components: {
    AlTooltipBtn,
    ErrorAlert
  },

  props: {
    sectionFields: {
      type: Array as PropType<IWorkflowFormSectionFieldData[]>,
      required: true
    },
    selectedConstraint: {
      type: Object as PropType<IWorkflowFormSectionFieldConstraint>,
      required: true
    },
    selectedFieldIndex: { type: Number, required: true },
    templateId: { type: Number },
    drawer: { type: Boolean }
  },

  inject: {
    isFormDisabled: {
      default: false
    }
  },

  data() {
    return {
      WorkflowConstraintActionEnum,
      WorkflowConstraintConditionTypeEnum,
      WorkflowConstraintConditionComparisonOperators,
      WorkflowFormFieldType,
      loading: false,
      errorMessage: '',
      detailErrorMessage: '',
      isConstraintsValid: true
    };
  },

  computed: {
    ...mapGetters({
      getWorkflowFormTemplateRevisionById:
        'workflowFormTemplate/getWorkflowFormTemplateRevisionById'
    }),

    navDrawer: {
      get(): boolean {
        return this.drawer;
      },
      set(value: boolean) {
        this.$emit('update:drawer', value);
      }
    },

    conditionTypeList(): IWorkflowFormFieldConstraintConditionType[] {
      return WorkflowFormFieldConstraintConditionType.getWorkflowFormFieldConstraintConditionTypeList();
    },

    comparisonOperatorList(): IWorkflowFormFieldConstraintComparisonType[] {
      return WorkflowFormFieldConstraintComparisonOperators.getWorkflowFormFieldConstraintComparisonTypeList();
    },

    nonNumericWorkflowFormFieldConstraintComparisonOperatorList(): IWorkflowFormFieldConstraintComparisonType[] {
      return [
        new WorkflowFormFieldConstraintComparisonOperators({
          display_name: 'Equals to:',
          value: WorkflowFormFieldConstraintComparisonOperators.Equals.value,
          icon: WorkflowFormFieldConstraintComparisonOperators.Equals.icon
        }),
        new WorkflowFormFieldConstraintComparisonOperators({
          display_name: 'Is answered',
          value: WorkflowConstraintConditionComparisonOperators.NotEquals,
          icon: 'mdi-not-equal'
        }),
        new WorkflowFormFieldConstraintComparisonOperators({
          display_name: 'Contains:',
          value: WorkflowFormFieldConstraintComparisonOperators.Contains.value,
          icon: WorkflowFormFieldConstraintComparisonOperators.Contains.icon
        })
      ];
    },

    selectedField(): IWorkflowFormFieldData {
      return this.sectionFields[this.selectedFieldIndex]
        .field_template as IWorkflowFormFieldData;
    }
  },

  methods: {
    numericValidator,
    requiredValidator,
    extractTextFromHtml,

    clearAllErrors() {
      this.detailErrorMessage = '';
      this.errorMessage = '';
    },

    closeDrawer() {
      if (this.validateConstraints()) {
        this.clearAllErrors();
        this.navDrawer = false;
      }
    },

    validateConstraints() {
      let valid = false;
      if (this.$refs.constraintsForm) {
        valid = (this.$refs.constraintsForm as ALForm).validate();
      }
      return valid;
    },

    updateConditionType(
      condition: IWorkflowFormSectionFieldConstraintConditionData
    ) {
      condition.field_option = null;
      condition.comparison_operator = null;
      condition.comparison_value = '';
    },

    isSectionFieldInvalid(sectionField: IWorkflowFormSectionFieldData) {
      return (
        (sectionField.field_template as IWorkflowFormFieldData).options!
          .length === 0
      );
    },

    isQuestionNumericById(
      questions: IWorkflowFormSectionFieldData[],
      sectionFieldId?: number
    ) {
      if (!sectionFieldId) return false;
      const found = questions.find(q => q.id === sectionFieldId);
      if (!found) return false;
      const type = (found.field_template as IWorkflowFormFieldData).type;
      return type === WorkflowFormFieldTypeEnum.NumericField;
    },

    getFieldQuestionsBeforeSelectedField(
      conditionType: WorkflowConstraintConditionTypeEnum
    ) {
      const questionFields = [] as IWorkflowFormSectionFieldData[];

      const template: IWorkflowFormTemplateRevision = this.getWorkflowFormTemplateRevisionById(
        this.templateId
      );

      let sectionField = {} as IWorkflowFormSectionFieldData;
      let index = 0;

      while (
        index < template.sections!.length &&
        sectionField?.id != this.sectionFields[this.selectedFieldIndex].id
      ) {
        const sectionFields = template.sections![index].section_fields;

        for (let i = 0; i < sectionFields.length; i++) {
          sectionField = sectionFields[i];
          if (
            sectionField?.id == this.sectionFields[this.selectedFieldIndex].id
          ) {
            break;
          }

          if (
            conditionType == WorkflowConstraintConditionTypeEnum.OptionBased
          ) {
            if (
              OPTION_BASED_FIELD_TYPES.includes(
                (sectionField.field_template as IWorkflowFormFieldData).type
              )
            ) {
              questionFields.push(sectionField);
            }
          } else if (
            conditionType == WorkflowConstraintConditionTypeEnum.ValueBased
          ) {
            questionFields.push(sectionField);
          }
        }
        index++;
      }

      return questionFields;
    },

    genSelectedFormQuestionOptions(
      field: number,
      conditionType: WorkflowConstraintConditionTypeEnum
    ) {
      const formField = this.getFieldQuestionsBeforeSelectedField(
        conditionType
      ).find(question => question.id == field);

      if (!formField) return [];
      return (formField.field_template as IWorkflowFormFieldData).options ?? [];
    },

    removeConstraintCondition(index: number) {
      this.selectedConstraint.conditions.splice(index, 1);
    },

    addConstraintCondition() {
      const condition = new WorkflowFormSectionFieldConstraintCondition({
        condition_type: WorkflowConstraintConditionTypeEnum.OptionBased,
        form_section_field: 0
      });
      this.selectedConstraint.conditions.push(condition);
    }
  },

  setup(props, ctx) {
    const navDrawerRef = ref<{
      getOpenDependentElements: () => HTMLElement[];
    }>();

    function conditionIncludeElements() {
      return (navDrawerRef.value as any)?.getOpenDependentElements();
    }
    return {
      navDrawerRef,
      conditionIncludeElements
    };
  }
});
